import { FiltersSetDataExtended } from '@models/interfaces';

export const DEFAULT_FILTERS_SET_VALUE: FiltersSetDataExtended = {
  name: '',
  filter: {},
  paceTaskFilter: [],
  setFields: [],
  paceTaskFields: [],
};
